import axios from 'axios'
// import qs from 'qs'

// 设置默认的 Content-Type 为 application/json
axios.defaults.headers.post['Content-Type'] = 'application/json'
// 默认将响应类型设置为流数据
// axios.defaults.responseType = 'stream'

// 创建一个 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 100000, // 请求超时时间
  responseType: 'stream' // 请求超时时间
  // paramsSerializer (params) {
  //   return JSON.stringify(params)
  // }
})

// POST 传参序列化
service.interceptors.request.use((config) => {
  if (config.method === 'post') {
    // 检查 config.data 是否存在
    if (config.data) {
      if (typeof config.data === 'object') {
        // 如果是对象，将其序列化为 JSON 字符串
        config.data = JSON.stringify(config.data)
      } else {
        console.warn('POST 请求的 data 不是对象类型')
      }
    } else {
      console.warn('POST 请求的 data 字段为空')
    }
  }
  return config
}, (error) => {
  console.error('请求拦截器出错:', error)
  // return Promise.reject(error)
})

service.interceptors.response.use(response => {
  // console.log('响应流数据:', response)
  // 检查响应状态码
  if (response.status === 200 && response.status < 300) {
    // 对于流数据，直接返回响应对象
    return response
  } else {
    console.error(`响应状态码异常: ${response.status} ${response.statusText}`)
    // return Promise.reject(new Error(`响应状态码异常: ${response.status} ${response.statusText}`))
  }
}, (error) => {
  console.error('响应拦截器出错:', error)
  if (error.response) {
    // console.error('响应数据:', error.response.data)
    // console.error('响应状态码:', error.response.status)
    // console.error('响应头:', error.response.headers)
  }
  // return Promise.reject(error)
})

export default service
